<template>
  <tr class="cursor-pointer history-item" :class="{ loading: isLoading }">
    <td @click="setProjectSite(history)">{{ history.user.name }} {{ history.user.last_name }}</td>
    <td @click="setProjectSite(history)">{{ convertToJalaliWithTime(history.created_at) }}</td>
    <td>
      <i class="bi mx-1 bi-files" @click="copyJson(history)"></i>
      <i
        v-if="checkHistoryHaveLog(history)"
        class="bi mx-1 bi-check-square-fill"
        data-toggle="modal"
        :data-target="`#${modalId}`"
        @click="onOpenClick"
      ></i>

      <teleport to="body">
        <div
          class="modal fade"
          :id="modalId"
          tabindex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">گزارش بیلد #{{ history.id }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body text-left" dir="ltr">
                <pre class="miw-build-log-pre">{{ buildLog || 'در حال بارگذاری...' }}</pre>
              </div>
            </div>
          </div>
        </div>
      </teleport>
    </td>
  </tr>
</template>

<script>
import $ from 'jquery'
import {convertToJalaliWithTime} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter'
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "HistoryItem",
  props: {
    history: {required: true},
  },
  data() {
    return {
      buildLog: '',
      intervalId: null,
      currentHistory: null,
      isLoading: false,
    }
  },
  computed: {
    modalId() {
      return `miw-history-build-log-${this.history.id}`
    }
  },
  methods: {
    convertToJalaliWithTime,
    async setProjectSite(historyItem) {
      if (this.isLoading) return
      this.isLoading = true
      try {
        const parsed = JSON.parse(historyItem.json)
        if (!parsed || !parsed.site) {
          toast('ساختار سیو نامعتبر است', 'ساختار سیو نامعتبر است', 'danger')
          return
        }

        await this.$store.dispatch('Site/setSite', parsed.site)
        await this.$store.commit('Site/setGlobalStyle', parsed.global_style ?? '')
        await this.$store.dispatch('Site/setGlobalRoutes', parsed)

        toast('سیو بارگذاری شد', 'سیو بارگذاری شد')
      } catch (e) {
        console.error('setProjectSite failed', e)
        toast('خطا در بارگذاری سیو', 'خطا در بارگذاری سیو', 'danger')
      } finally {
        this.isLoading = false
      }
    },
    copyJson(history) {
      history = history.json;
      navigator.clipboard.writeText(history).then(function () {
        toast('کپی با موفقیت انجام شد', 'کپی با موفقیت انجام شد')
      }, function (err) {
        console.log('Copy Error => ', err)
      });
    },
    async loadHistoryData(history) {
      let form = {
        history_id: history.id
      }
      let req = await this.$store.dispatch('Site/getHistoryLog', form)
      this.buildLog = req.data.data[0].value
    },
    checkHistoryHaveLog(history) {
      let checker = history.meta.find(item => {
        return item.name == 'build_log'
      });
      return checker != undefined
    },
    onOpenClick() {
      this.loadHistoryData(this.history)
    },
    startPolling(history) {
      this.stopPolling()
      this.currentHistory = history;
      this.loadHistoryData(history);
      this.intervalId = setInterval(() => {
        this.loadHistoryData(this.currentHistory);
      }, 2000);
    },
    stopPolling() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = null;
      this.currentHistory = null;
    },
    onModalShown() {
      this.startPolling(this.history)
    },
    onModalHidden() {
      this.stopPolling()
    },
  },
  mounted() {
    this.$nextTick(() => {
      const $modal = $(`#${this.modalId}`)
      $modal.on('shown.bs.modal', this.onModalShown)
      $modal.on('hidden.bs.modal', this.onModalHidden)
    })
  },
  beforeUnmount() {
    const $modal = $(`#${this.modalId}`)
    $modal.off('shown.bs.modal', this.onModalShown)
    $modal.off('hidden.bs.modal', this.onModalHidden)
    this.stopPolling()
  }
}
</script>

<style scoped>
.history-item {
  font-size: 12px;
}

.history-item.loading {
  opacity: 0.55;
  pointer-events: none;
}

.cursor-pointer {
  cursor: pointer;
}

.miw-build-log-pre {
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
  background: #1f1f1f;
  color: #ddd;
  padding: 12px;
  border-radius: 6px;
  max-height: 60vh;
  overflow: auto;
  margin: 0;
}
</style>
